import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteDeliveryVoucherActions as Actions,
  DeleteDeliveryVoucherRequestAction as RequestAction,
} from 'store/ducks/deliveryVouchers';

export function* deleteDeliveryVoucherRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `delivery-vouchers/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Canhoto removido com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
